import React from 'react';
import { NotesSectionProps } from '../../types';
import { 
  NotesSection as NotesContainer,
  NotesHeader,
  IconWrapper,
  NotesTitle,
  NotesTextarea,
  ReminderText 
} from '../../styles';

const NotesSection: React.FC<NotesSectionProps> = ({ 
  notes, 
  professionalName,
  onNotesChange,
  onSave,
  isSaving
}) => {
  return (
    <NotesContainer>
      <NotesHeader>
        <IconWrapper>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="4" y="3" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M8 7H12M8 10H12M8 13H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </IconWrapper>
        <NotesTitle>Personal Notes</NotesTitle>
      </NotesHeader>
      
      <NotesTextarea
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        placeholder="Enter private notes - only you will see this."
      />
      
      <ReminderText>
        <strong>A friendly reminder:</strong> Standard placement fees apply to 
        future shifts booked with {professionalName} - whether arranged on the 
        app or through direct contact.
      </ReminderText>
    </NotesContainer>
  );
};

export default NotesSection; 